import React from 'react'
import RateAppModal from './RateAppModal'

export default function Onboarding() {
  return <RateAppModal />
}
